<ag-grid-angular
                #aboutGrid
                *ngIf="gridOptions != null"
                 class="ag-theme-balham flex-fill"
                 [gridOptions]="gridOptions"
                 style="height:768px; width:1366px; margin-left:8px; margin-top:8px;"></ag-grid-angular>
